const Keys = {
    googleVision: '',
    vapid: '',
    firebase: '',
    ClientID: '5538f162-80b9-43db-bb99-ff64047a2551',
    TenantID: '3485b963-82ba-4a6f-810f-b5cc226ff898',
};

export default Keys;
